import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Microsoft Entra External ID authentication.
 * Environment variables must be prefixed with VITE_ for Vite to expose them.
 */

const clientId = import.meta.env.VITE_AUTH_CLIENT_ID || '';
const authority = import.meta.env.VITE_AUTH_AUTHORITY || '';
const knownAuthority = import.meta.env.VITE_AUTH_KNOWN_AUTHORITY || '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    knownAuthorities: knownAuthority ? [knownAuthority] : [],
    redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_AUTH_POST_LOGOUT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            break;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            break;
          case LogLevel.Info:
            if (import.meta.env.DEV) {
              console.info('[MSAL]', message);
            }
            break;
          case LogLevel.Verbose:
            if (import.meta.env.DEV) {
              console.debug('[MSAL]', message);
            }
            break;
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Verbose : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes requested during user sign-in.
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/**
 * Scopes required when calling the backend API.
 */
export const apiRequest = {
  scopes: [
    import.meta.env.VITE_AUTH_API_SCOPE || `api://${clientId}/access_as_user`,
  ].filter(Boolean),
};
